import React, { Component } from 'react'
import GetContentsList from '../../Services/Queries/GetContentsList'
import PublishContent2Point0 from '../../Services/Mutations/PublishContent2Point0'
import DeleteContent from '../../Services/Mutations/DeleteContent'
import GetContent from '../../Services/Queries/GetContent'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ReactReadMoreReadLess from 'react-read-more-read-less'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import ArchiveContentFromRedis from '../../Services/Mutations/ArchiveContent'
import AddContentToBoxOffice from '../../Services/Mutations/AddContentToBoxOffice'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import _ from 'lodash'
import { heightPercentageToDP, widthPercentageToDP } from '../../Utils/ResponsiveScreen'
import MDEditor from '@uiw/react-md-editor'
import html2canvas from 'html2canvas'
import { fonts } from '../Constants/theme'
import AddPointsToContent from './AddPointsToContent'
import NewsOnTop from './NewsOnTop'
import AwsConfig from '../../Config/AwsConfig'
import DeleteContentInSingleLanguage from '../../Services/Mutations/DeleteContentInSingleLanguage'

class ShareContentAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filtered: false,
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
      archiveModalVisible: false,
      addToBoxOfficeModalVisible: false,
      showDatePicker: false,
      error: false,
      publishedContentsList: [],
      limit: 100,
      nextToken: null,
      render: false,
      endReached: false,
      loadMore: false,
      props: props,
      userDetails: {},
      userPermissions: [],
      reload: false,
      contentSelectedLang: null,
      currentPage: 1,
      headings: [
        'Num',
        'Actions',
        'Created Date',
        'Published Date',
        'Thumbnail',
        'Title',
        'Description',
        'Polled Count',
        'Points',
        'Likes',
        'Views',
        'Shares',
        'Comments',
        'Created From',
        'Scheduled',
        'Scheduled Date',
        'ContentID',
        'ContentType',
        'Main Category',
        'Archived',
        'Content Languages',
        'Approved Languages',
        'Target Areas',
      ],
      deleteModalVisible: false,
      selectedContentId: '',
      selectedContentLanguages: [],
      capturePostModal: false,
      selectedItem: null,
      displayDescription: '',
      displayContents: ['Story', 'CoverStory', 'Mcq', 'Poll', 'SlideShow'],
      contentsTypes: ['Story', 'CoverStory', 'Mcq', 'Poll', 'SlideShow'],
    }
  }
  openCapturePostModal = (item) => {
    this.setState({ selectedItem: item, capturePostModal: true, displayDescription: '' })
  }
  closeCapturePostModal = () => {
    this.setState({ selectedItem: null, capturePostModal: false })
  }
  PrintDiv = (storyTitle) => {
    html2canvas(document.getElementById('sharecard'), {
      useCORS: true,
    }).then(function(canvas) {
      var imageURL = canvas.toDataURL('image/png')
      let a = document.createElement('a')
      a.href = imageURL
      a.download = storyTitle
      a.click()
    })
  }
  getContentUri = (item) => {
    let uri
    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      pollDetails,
      slideShowDetails,
      thumbnailURL,
    } = item.contentMetaInfo
    const cdnurl = AwsConfig.cdn_url
    switch (item.contentType) {
      case 'Story':
        uri =
          storyDetails &&
          storyDetails.storyCardImages &&
          storyDetails.storyCardImages[0] &&
          storyDetails.storyCardImages[0].image
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri
        }
        if (uri == undefined && storyDetails && storyDetails.youtubeID != '') {
          uri = `https://img.youtube.com/vi/${storyDetails.youtubeID}/default.jpg`
        }
        if (!uri && thumbnailURL) {
          uri = thumbnailURL
          if (uri && !uri.includes(cdnurl)) {
            uri = cdnurl + thumbnailURL
          }
        }
        break
      case 'Mcq':
        uri =
          mcqDetails &&
          mcqDetails.mcqImages &&
          mcqDetails.mcqImages[0] &&
          mcqDetails.mcqImages[0].image
        break
      case 'Poll':
        uri =
          pollDetails &&
          pollDetails.pollImage &&
          pollDetails.pollImage[0] &&
          pollDetails.pollImage[0].image
        break
      case 'CoverStory':
        const { flipToStoryDetails, onlyCoverDetails, inAppBrowserDetails } = coverStoryDetails
        switch (coverStoryDetails.coverStoryType) {
          case 'FlipToStory':
            uri =
              flipToStoryDetails &&
              flipToStoryDetails.coverStoryImages &&
              flipToStoryDetails.coverStoryImages[0] &&
              flipToStoryDetails.coverStoryImages[0].image
            if (uri == undefined && flipToStoryDetails && flipToStoryDetails.youtubeID != '') {
              uri = `https://img.youtube.com/vi/${flipToStoryDetails.youtubeID}/default.jpg`
            }
            if (!uri && thumbnailURL) {
              uri = thumbnailURL
              if (uri && !uri.includes(cdnurl)) {
                uri = cdnurl + thumbnailURL
              }
            }
            break
          case 'OnlyCover':
            uri =
              onlyCoverDetails &&
              onlyCoverDetails.coverStoryImages &&
              onlyCoverDetails.coverStoryImages[0] &&
              onlyCoverDetails.coverStoryImages[0].image
            if (uri == undefined && onlyCoverDetails && onlyCoverDetails.youtubeID != '') {
              uri = `https://img.youtube.com/vi/${onlyCoverDetails.youtubeID}/default.jpg`
            }
            if (!uri && thumbnailURL) {
              uri = thumbnailURL
              if (uri && !uri.includes(cdnurl)) {
                uri = cdnurl + thumbnailURL
              }
            }
            break
          case 'InAppBrowser':
            uri =
              inAppBrowserDetails &&
              inAppBrowserDetails.coverStoryImages &&
              inAppBrowserDetails.coverStoryImages[0] &&
              inAppBrowserDetails.coverStoryImages[0].image
            break
          default:
            uri = ''
        }
        break
      case 'SlideShow':
        uri = slideShowDetails && slideShowDetails.slideShowImage
        break
      default:
        uri = ''
    }
    return uri
  }
  renderCapturePostModal = () => {
    const { selectedItem, displayDescription } = this.state
    if (selectedItem) {
      let lang = 'En'
      if (selectedItem.contentLanguages) {
        lang = selectedItem.contentLanguages.includes('En') ? 'En' : 'Te'
      }
      const { storyDetails } = selectedItem?.contentMetaInfo
      const storyTitle = storyDetails[`storyTitle_${lang}`]
      const storyCardDescription = storyDetails[`storyCardDescription_${lang}`]
      const displayDescriptionVal =
        displayDescription == '' ? storyCardDescription : displayDescription
      return (
        <Modal show={this.state.capturePostModal} onHide={() => this.closeCapturePostModal()}>
          <Modal.Body>
            <div className='row' style={{ alignItems: 'center', justifyContent: 'center' }}>
              <div
                style={{
                  marginTop: heightPercentageToDP('1'),
                  marginBottom: heightPercentageToDP('1'),
                  textAlign: 'center',
                }}
              >
                <text style={{ textAlign: 'center', fontWeight: 'bold' }}>Download Image</text>
              </div>
              <div class='row' style={{ marginTop: 5, marginBottom: 5 }}>
                <text style={{ fontWeight: 'bold' }}>Description :</text>
                <textarea
                  type='text'
                  onChange={(e) => {
                    this.setState({ displayDescription: e.target.value })
                  }}
                  value={displayDescriptionVal}
                ></textarea>
              </div>
              <text style={{ fontWeight: 'bold' }}>Image Thumbnail :</text>
              <div
                style={{
                  width: widthPercentageToDP('100%'),
                  height: widthPercentageToDP('100%'),
                  backgroundColor: 'black',
                  padding: 0,
                }}
                id='sharecard'
              >
                <div
                  style={{
                    marginTop: heightPercentageToDP('1%'),
                    marginBottom: heightPercentageToDP('1%'),
                    textAlign: 'center',
                  }}
                >
                  <text
                    style={{
                      color: 'yellow',
                      fontFamily: fonts.fontFamilyPoppinsLight,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      fontSize: heightPercentageToDP('1.8%'),
                    }}
                  >
                    {storyTitle}
                  </text>
                </div>
                <div style={{ overflow: 'hidden', height: widthPercentageToDP('65%') }}>
                  <img
                    style={{
                      width: widthPercentageToDP('100%'),
                    }}
                    src={selectedItem ? this.getContentUri(selectedItem) : ''}
                  />
                </div>
                <div
                  style={{
                    marginTop: heightPercentageToDP('0.5%'),
                    marginBottom: heightPercentageToDP('0.5%'),
                    paddingLeft: widthPercentageToDP('1%'),
                    paddingRight: widthPercentageToDP('1%'),
                  }}
                >
                  <MDEditor.Markdown
                    className='sharecontentEllipsesStyle'
                    style={{
                      color: 'white',
                      textAlign: 'center',
                      fontSize: heightPercentageToDP('1.6%'),
                      overflow: 'hidden',
                    }}
                    source={displayDescriptionVal}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeCapturePostModal()}>Cancel</Button>
            <Button onClick={() => this.PrintDiv(storyTitle)}>DownLoad Image</Button>
          </Modal.Footer>
        </Modal>
      )
    } else {
      return null
    }
  }

  render() {
    return (
      <div>
        <div
          onClick={() => {
            this.openCapturePostModal(this.props.item)
          }}
        >
          <label>Share Content</label>
        </div>

        {this.renderCapturePostModal()}
      </div>
    )
  }
}

export default ShareContentAction
